import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useSettings, waLink } from "../../lib/api";

export default function PublicLayout() {
  const { pathname, search } = useLocation();
  const { data: s } = useSettings();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <a
        href={waLink(s?.whatsapp, "Halo Sembada Satwa, saya ingin bertanya.")}
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform hover:scale-110"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
    </div>
  );
}
